
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/platform/pietra-ai",
      function () {
        return require("private-next-pages/platform/pietra-ai/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/platform/pietra-ai"])
      });
    }
  